import {
  AgendaItemMetadataConfigSchema,
  AppConfigSchema,
  DocumentUploadTypesConfigSchema,
  ExampleFilesConfigSchema,
  MeetingTypesConfigSchema,
  MotionTypesConfigSchema,
  OrganizationTypesConfigSchema,
  TermsAndConditionsConfigSchema,
} from "../../models/config.schema";

export const PrivateConfigControllerResponseSchema = {
  getAppConfig: AppConfigSchema,

  getAgendaItemMetadataConfig: AgendaItemMetadataConfigSchema,

  getExampleFileConfig: ExampleFilesConfigSchema,

  getMeetingTypeConfig: MeetingTypesConfigSchema,

  getOrganizationTypesConfig: OrganizationTypesConfigSchema,

  getDocumentUploadTypesConfig: DocumentUploadTypesConfigSchema,

  getMotionTypesConfig: MotionTypesConfigSchema,

  getTermsAndConditionsConfig: TermsAndConditionsConfigSchema,
};
